export const AUDITS_LIST_KEY = 'AUDITS_LIST';
export const AUDITS_ONE_KEY = 'AUDITS_ONE_KEY';
export const AUDITS_ONE_POPULATED_KEY = 'AUDITS_ONE_POPULATED_KEY';
export const AUDIT_SECTIONS_LIST_KEY = 'AUDITS_SECTIONS_LIST_KEY';
export const AUDIT_ITEMS_LIST_KEY = 'AUDIT_ITEMS_LIST_KEY';
export const AUDIT_ITEMS_ONE_KEY = 'AUDIT_ITEMS_ONE_KEY';
